<template>
  <div class="experience-item-page">
    <div class="experience-step">
      <div class="experience-icon">
        <div class="inner-icon"></div>
      </div>
      <div class="experience-line" v-if="!isEnd"></div>
    </div>
    <div class="experience-card">
      <p class="post-name">{{(data.type === 'school' ? data.university : data.title) || '该信息已隐藏'}}</p>
      <div class="time-box">
        <p class="time">{{data.start_at ? data.start_at.substr(0, 7).replace(/\-/g,'.'): ''}}{{(data.end_at || data.present) && data.start_at ? '-' : ''}}{{data.end_at ? data.end_at.substr(0, 7).replace(/\-/g,'.') : ( data.present ? data.present : '')}}</p>
        <p class="site">{{data.city}}</p>
      </div>
      <div class="company-info-box">
        <div class="company">
          <img  src="https://files.wondercv.com/PC/editor/planning/company.png" width="24" v-if="data.type != 'school'"/>
          <span>{{(data.type === 'school' ? ((data.major || data.degree) ? (data.major + ' ' + data.degree) : '') : data.company) || '该信息已隐藏'}}</span>
        </div>
        <div class="detail-btn" @click.stop="handleClickDetail" v-if="data.type != 'school' && data.company">
          <i class="iconfont iconbar-chart-"></i>
          <span>详情</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "experience-item",
    props:{
      isEnd: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object,
        default: ()=>({})
      }
    },
    methods:{
      handleClickDetail(){
        this.$emit("on-detail", this.data.company)
      }
    }
  }
</script>

<style scoped lang="scss">
.experience-item-page{
  height: 157px;
  width: 432px;
  display: flex;
  justify-content: space-between;
  .experience-step{
    display: flex;
    flex-direction: column;
    align-items: center;
    .experience-icon{
      width: 20px;
      height: 20px;
      background: #606060;
      border-radius: 50%;
      .inner-icon{
        width: 12px;
        height: 12px;
        background: #BCBCBC;
        margin: 4px;
        border-radius: 50%;
      }
    }
    .experience-line{
      width: 2px;
      height: 100%;
      opacity: 0.4;
      background: #FFFFFF;
    }
  }
  .experience-card{
    width: 380px;
    height: 137px;
    background: #313744;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    padding: 20px 24px 12px;
    .post-name{
      font-size: 18px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 25px;
      margin-bottom: 3px;
      width: 100%;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .time-box{
      display: flex;
      justify-content: space-between;
      padding-bottom: 12px;
      border-bottom: 1px solid rgba(70, 75, 87, 1);
      margin-bottom: 12px;
      p{
        min-height: 20px;
      }
      .time{
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        line-height: 20px;
      }
      .site{
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.4);
        line-height: 20px;
      }
    }
    .company-info-box{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .company{
        flex: 1;
        display: flex;
        align-items: center;
        img {
          border-radius: 4px;
          margin-right: 12px;
        }
        & > span{
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 20px;
          width: 200px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }
      .detail-btn{
        width: 80px;
        height: 32px;
        background: #3E4556;
        border-radius: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
        i{
          color: #ffffff;
        }
        &:hover{
          background: #4D566B;
        }
      }
    }
  }
}
</style>
